
import { applicantStore } from '@/store'
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class PersonDetails extends Vue {
    get personCode (): string {
        return applicantStore.personCode
    }

    get fullName (): string {
        return applicantStore.applicantFullName
    }
}
